import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = [ 'map', 'modal' ];
    static values = { gcpId: String };

    connect() {
        if (typeof(google) != "undefined") {
            this.initMap();
        }
    }

    initMap() {
        // init the marker and map.
        const waterloo = new google.maps.LatLng(43.466667, -80.516670);
        this.map = new google.maps.Map(this.mapTarget, {
            center: waterloo, // waterloo coords
            zoom: 15,
            panControl: false,
            fullscreenControl: false,
            mapTypeControl: false
        });
        this.marker = new google.maps.Marker({
            map: this.map,
            position: waterloo,
            visible: false
        });

        // do the search
        let searchService = new google.maps.places.PlacesService(this.map);
        let req = {
            placeId: this.gcpIdValue,
            fields: ['geometry'],
        };
        searchService.getDetails(req, (place, status) => {
            if (place.geometry.viewport) {
                this.map.fitBounds(place.geometry.viewport);
            } else {
                this.map.setCenter(place.geometry.location);
            }
            this.marker.setPosition(place.geometry.location);
            this.marker.setVisible(true);
        });
    }

    toggleReviewModal(e) {
        e.preventDefault();
        this.modalTarget.classList.toggle('hidden');
    }

};
